var Shopify = Shopify || {};

Shopify.optionsMap = {};
Shopify.inStockMap = {};

function changeUnitPrice (value) {
  jQuery('#unit-price').html(Shopify.formatMoney(value + upsellPrice, moneyFormat));
}

function changePriceValue (cell, value, variant) {
  var newPrice = value + upsellPrice;
  
  jQuery(cell).html(Shopify.formatMoney(newPrice, moneyFormat));

  if (variant.unit_price) {
    jQuery('#unit-price').html(`<small class="alert-info fw-bold rounded-pill px-3 py-1">${Shopify.formatMoney(newPrice / variant.unit_price_measurement.quantity_value, moneyFormat)} Per Unit</small>`);
  } else {
    jQuery('#unit-price').html("");
  }
}

function changeRcdPriceValue (cell, value, variant) {
  var newPrice = (value + upsellPrice) * 0.95;
  
  jQuery(cell).html(Shopify.formatMoney(newPrice, moneyFormat));

  if (variant.unit_price) {
    console.log("changing unit price for rcd")
    jQuery('#rcd-unit-price').html(`<small class="alert-info fw-bold rounded-pill px-3 py-1">${Shopify.formatMoney(newPrice / variant.unit_price_measurement.quantity_value, moneyFormat)} Per Unit</small>`);
  } else {
    jQuery('#rcd-unit-price').html("");
  }
}

function changePriceValueTaxable (cell, value, variant) {
  changePriceValue(cell, value, variant);
}
function changeRcdPriceValueTaxable (cell, value, variant) {
  changeRcdPriceValue(cell, value, variant);
}

function changeVatPriceValue (cell, value) {
  jQuery(cell).html(Shopify.formatMoney((value + upsellPrice) * 1.2, moneyFormat));
}

function changeVatPriceOldValue (cell, value) {
  jQuery(cell).html("<s>" + Shopify.formatMoney((value + upsellPrice) * 1.2, moneyFormat) + "<s>");
}

function changeRcdVatPriceValue (cell, value) {
  jQuery(cell).html(Shopify.formatMoney(((value + upsellPrice) * 0.95) * 1.2, moneyFormat) + " Including VAT");
}

function newVariantTextData (obj, value) {
  if(value != '') {
    jQuery(obj).parent().show();
    jQuery(obj).text(value);
  }
  else {
    jQuery(obj).parent().hide();
    jQuery(obj).text('');
  }
}

function updateLidOptions () {
  var $selectedCupSizeEl = $('.swatch.original[data-option-index="0"] :radio:checked');
  let selectedCupSize = $selectedCupSizeEl.val();
  var selectedCupQuantity = $('.swatch.original[data-option-index="1"] :radio:checked').val();

  if ($selectedCupSizeEl.data('lidSize')) {
    selectedCupSize = $selectedCupSizeEl.data('lidSize');
  }

  if (selectedCupSize && selectedCupQuantity) {
    var quantity = selectedCupQuantity.match(/\d+/) ? selectedCupQuantity.match(/\d+/)[0] : null;
    var size = '-' + selectedCupSize + '-';
    
    const upsellVariants = $('.swatch.lids .swatch-element');
    let matchingSizeCount = 0;
    
    upsellVariants.each(function() {
      if($(this).data('quantity')){
        if($(this).data('size').indexOf(size) != -1 && $(this).data('quantity').match(/\d+/) == quantity){
          $(this).show();
          matchingSizeCount = matchingSizeCount+1;
        } else {
          $(this).hide().find(':radio').removeAttr('checked');
        }
      }
    });
    
    if (matchingSizeCount == 0) {
      $('.swatch.lids .swatch-element.no-lids').show();
      $('.swatch.lids .swatch-element.no-lids').find(':radio').prop('checked', true);
    }
  }
  
  if ($('.swatch.lids .swatch-element :radio:checked').length == 0) {
    $('.swatch.lids .swatch-element.no-lids').find(':radio').prop('checked', true);
  }
}

var selectCallback = function(variant, selector) {
  var _parent = '.product-info';
  var _parentprice = _parent + ' .price-box';
  var _rcdprice = '.rcd-price';
  var _vatprice = '.vat-price';
  var _vatpriceold = '.vat-price-old';
  var _rcdvatprice = '.rcd-vat-price';

  if ($('#contactSelectedSku').length) {
    $('#contactSelectedSku').val(variant.sku);
    $('#selectedSku').text(variant.sku);
  }

  upsellPrice = 0;

  if (hasUpselling) {
    var data = $("#add-item-form").serializeArray();
    var upsellSku = $('input:radio');

    updateLidOptions();
    
    data.forEach(function (item) {

      if(item != "skip" && typeof upsellingPricing[item.value] !== 'undefined') {

        upsellPrice = upsellPrice + upsellingPricing[item.value];
      }   
    });
  }

  if (!variant) {
    return false;
  }

  if ($('#variantBtn').length > 0) {
    var variant_url = $('#variantBtn').attr('href');
    var new_url = variant_url.split("/");
    new_url.pop();
    new_url.push(variant.id);
    new_url = new_url.join("/");

    $('#variantBtn').attr('href', new_url);
    $('#currentStockAdmin').text(variant.inventory_quantity);
  }

  if (variant.inventory_management) {
    if (variant.inventory_policy == 'continue') {
      jQuery(_parent + ' .qty-input').attr('max', 999)
    } else {
      jQuery(_parent + ' .qty-input').attr('max', variant.inventory_quantity > 0 ? variant.inventory_quantity : 0);
    }
  } else {
    jQuery(_parent + ' .qty-input').attr('max', 999);
  }

  if(variant.price < variant.compare_at_price){
    jQuery(_parentprice + '>span:last-child').addClass('price-box__old');
    jQuery(_parentprice + '>span:first-child').show();
    if(variant.taxable) {
      changePriceValueTaxable(_parentprice + '>span:last-child', variant.compare_at_price, variant);
      //             changeVatPriceOldValue(_vatpriceold, variant.compare_at_price);
      changePriceValueTaxable(_parentprice + '>span:first-child', variant.price, variant);
    } else {
      changePriceValue(_parentprice + '>span:last-child', variant.compare_at_price, variant);
      changePriceValue(_parentprice + '>span:first-child', variant.price, variant);
    }
    jQuery('.product_message_alarm').show();
  } else {
    jQuery(_parentprice + '>span:first-child').hide();
    jQuery(_parentprice + '>span:last-child').removeClass('price-box__old');
    if(variant.taxable) {
      changePriceValueTaxable(_parentprice + '>span:last-child', variant.price, variant);
    } else {
      changePriceValue(_parentprice + '>span:last-child', variant.price, variant);
    }
    jQuery('.product_message_alarm').hide();
  }

  if(variant.taxable) {
    changeRcdVatPriceValue(_rcdvatprice, variant.price);
    changeRcdPriceValueTaxable(_rcdprice, variant.price, variant);
    changeVatPriceValue(_vatprice, variant.price);
  } else {
    changeRcdPriceValue(_rcdprice, variant.price, variant);
  }  

  // BEGIN SWATCHES
  if (variant) {
    var form = jQuery('#' + selector.domIdPrefix).closest('form');
    for (var i=0,length=variant.options.length; i<length; i++) {
      var val = variant.options[i].replace(/'/g,"&#039;");
      var radioButton = form.find(".swatch[data-option-index='" + i + "'] :radio[value='" + val +"']");
      if (radioButton.size()) {
        radioButton.get(0).checked = true;
      }
    }
  }
  // END SWATCHES

  newVariantTextData(_parent + ' .sku', variant.sku);

  if(jQuery(_parent + ' .product-info__sku').length) {
    var $ava = jQuery(_parent + " .product-info__availability");
    if(variant.sku != "") {
      if($ava.hasClass('pull-left')){ $ava.removeClass('pull-left') }
    } else {
      if(!$ava.hasClass('pull-left')){ $ava.addClass('pull-left') }
    }
  }

  if (variant.available) {
    if(jQuery(_parent + " .product-info__availability .color-red").length) {
      jQuery(_parent + " .product-info__availability .color-red").removeClass('color-red');
    }
    if (variant.inventory_management == null || variant.inventory_policy == "continue") {
      jQuery(_parent + " .product-info__availability .color").text("In stock");
      jQuery('.product_message_alarm').hide();
    } else {
      jQuery(_parent + " .product-info__availability .color").text(variant.inventory_quantity + " In stock");
      if(variant.price < variant.compare_at_price && jQuery(".product_message_alarm").children().length) {
        var percent = Math.round(100 - (variant.price / variant.compare_at_price)*100);
        jQuery('.product_message_alarm .percent').text(percent);
        jQuery('.product_message_alarm .update_quantity_not_delete').text(variant.inventory_quantity);
      }
    }
  } else {
    jQuery(_parent + " .product-info__availability .color").text("Out of stock");
    jQuery(_parent + " .product-info__availability .color").addClass("color-red");
    jQuery('.product_message_alarm').hide();
  }

  // https://docs.shopify.com/support/your-website/themes/updating-a-theme-to-use-variant-images
  if (variant && jQuery("#bigImg").length > 0) {
    var originalImage = jQuery("#bigImg");
    let newImage = variant.featured_image;
    var element = originalImage[0];

    // Upselling variant image override
    if (hasUpselling) {
      if ($('.swatch.upsell.lids input:checked').data('upsellVariantImg')) {
        newImage = {src: $('.swatch.upsell.lids input:checked').data('upsellVariantImg')};
      } else {
        newImage = variant.featured_image ? variant.featured_image : {src: $('#mainProductImg').data('mainProductImg')};
      }

      if ($('.swatch.upsell.lids input:checked').data('upsellVariantImgs')) {
        var selectedCupSize = $('.swatch.original[data-option-index="0"] :radio:checked').val();
        var size = '-' + selectedCupSize.match(/\d+/) + '-';
        var upsellVariantImgs = $('.swatch.upsell.lids input:checked').data('upsellVariantImgs').split(',');

        upsellVariantImgs.forEach(function (e, i) {
          if (e.indexOf(size) > 0) {
            newImage = {src: e};
          }
        });
      }
    }
    // Upselling variant image override


    if (newImage) {
      Shopify.Image.switchImage(newImage, element, function (newImageSizedSrc, newImage, element) {
        jQuery('.zoomContainer').remove();
        jQuery(element).removeData('elevateZoom');
        jQuery(element).attr('src', newImageSizedSrc);
        jQuery(element).attr('zoom-image', newImageSizedSrc);
        elevateZoom();
      });
  
      if($("#mobileGallery").length) {
        var src = String(newImage.src).replace("https:", "").replace("http:", "");
        var arr = src.split('.');
        src = arr[0];
        for(var i=1; i<arr.length; i++) {
          src+= (i == arr.length-1 ? '_1024x1024.' : '.') + arr[i];
        }
        var num = jQuery('[src="'+src+'"]').last().parent().attr('data-slick-index');
        if(num) {
          var $container = $("#mobileGallery");
          $container.slick('slickGoTo', num);
        }
      }
    }
  }

  if (variant && variant.available) {
    jQuery(_parent + ' .addtocart').removeAttr('disabled');
    jQuery(_parent + ' .addtocart').html(`<span class="icon icon-shopping_basket"></span> Add to Cart`);
    jQuery('#productQtyBox').removeClass('d-none');
    jQuery('#stockNotify').addClass('d-none');
    jQuery('#orderProductSamples').removeClass('d-none');
  } else {
    jQuery(_parent + ' .addtocart').attr('disabled','disabled');
    jQuery(_parent + ' .addtocart').html('Unavailable');
    jQuery('#productQtyBox').addClass('d-none');
    jQuery('#stockNotify').removeClass('d-none');
    jQuery('#orderProductSamples').addClass('d-none');
  }
};

Shopify.updateOptionsInSelector = function(selectorIndex, UpdateLids = false) {

  if (hasUpselling) {
    var upsellSkus = jQuery('.swatch :radio:checked').map(function() {
      return jQuery(this).data('sku');
    }).get();
    
    if (upsellSkus.length > 0) {
      $('#upsellSkus').html(`<div class="product-info__sku pull-left">&nbsp;+ <strong>${upsellSkus.join(' + ')}</strong>`);
    } else {
      $('#upsellSkus').html('');
    }
    
    if (UpdateLids) {
      if ($('.swatch.lids').length) {
        updateLidOptions();
      }
    }
  }

  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = jQuery('.single-option-selector:eq(0)');
      break;
    case 1:
      var key = jQuery('.single-option-selector:eq(0)').val();
      var selector = jQuery('.single-option-selector:eq(1)');
      break;
    case 2:
      var key = jQuery('.single-option-selector:eq(0)').val();  
      key += ' / ' + jQuery('.single-option-selector:eq(1)').val();
      var selector = jQuery('.single-option-selector:eq(2)');
  }

  var initialValue = selector.val();
  selector.empty();

  var availableOptions = Shopify.optionsMap[key];
  var inStockOptions = Shopify.inStockMap[key];

  if (availableOptions) {
    for (var i=0; i<availableOptions.length; i++) {
      var option = availableOptions[i];
      var newOption = jQuery('<option></option>').val(option).html(option);
      selector.append(newOption);
    }
  }

  jQuery('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
    if (jQuery.inArray(jQuery(this).attr('data-value'), availableOptions) !== -1) {
      if (jQuery.inArray(jQuery(this).attr('data-value'), inStockOptions) !== -1) {
        jQuery(this).removeClass('soldout').show().find(':radio').removeAttr('checked');
      } else {
        jQuery(this).addClass('soldout').show().find(':radio').removeAttr('checked');
      }
    } else {
      jQuery(this).addClass('soldout').hide().find(':radio').removeAttr('checked');
    }
  });
  if (jQuery.inArray(initialValue, availableOptions) !== -1) {
    selector.val(initialValue);
  }

  selector.trigger('change');
};

Shopify.linkOptionSelectors = function(product) {
  // Building our mapping object.
  // loops for every variant on the current product
  for (var i=0; i<product.variants.length; i++) {
  // variant = the current variant
  var variant = product.variants[i];
    // Gathering values for the 1st drop-down.
    Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
    Shopify.optionsMap['root'].push(variant.option1);
    Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
    // Gathering values for the 2nd drop-down.
    if (product.options.length > 1) {
      var key = variant.option1;
      Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
      Shopify.optionsMap[key].push(variant.option2);
      Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
    }
    // Gathering values for the 3rd drop-down.
    if (product.options.length === 3) {
      var key = variant.option1 + ' / ' + variant.option2;
      Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
      Shopify.optionsMap[key].push(variant.option3);
      Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
    }

    // check if variant is in stock
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      Shopify.inStockMap['root'] = Shopify.inStockMap['root'] || [];
      Shopify.inStockMap['root'].push(variant.option1);
      Shopify.inStockMap['root'] = Shopify.uniq(Shopify.inStockMap['root']);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.inStockMap[key] = Shopify.inStockMap[key] || [];
        Shopify.inStockMap[key].push(variant.option2);
        Shopify.inStockMap[key] = Shopify.uniq(Shopify.inStockMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + ' / ' + variant.option2;
        Shopify.inStockMap[key] = Shopify.inStockMap[key] || [];
        Shopify.inStockMap[key].push(variant.option3);
        Shopify.inStockMap[key] = Shopify.uniq(Shopify.inStockMap[key]);
      }
    }
  }
  // Update options right away.
  Shopify.updateOptionsInSelector(0, true);
  if (product.options.length > 1) Shopify.updateOptionsInSelector(1, true);
  if (product.options.length === 3) Shopify.updateOptionsInSelector(2, true);

  // When there is an update in the first dropdown.
  jQuery(".single-option-selector:eq(0)").change(function() {
    Shopify.updateOptionsInSelector(1, true);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, true);
    return true;
  });

  // When there is an update in the second dropdown.
  jQuery(".single-option-selector:eq(1)").change(function() {
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, true);
    if ($('.swatch.lids').length) updateLidOptions();
    return true;
  });

  // When there is an update in the third dropdown.
  jQuery(".single-option-selector:eq(2)").change(function() {
    if ($('.swatch.lids').length) updateLidOptions();
    return true;
  });
};

// ON READY
jQuery(function() {
  // NORMAL SWATCHES
  jQuery('.swatch.original :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
  });
  
  if(jQuery(".selector-wrapper label").length) {
    jQuery(".selector-wrapper label").each(function( index ) {
      jQuery(this).text(jQuery(this).text() + ":");
    });
  }

  // UPSELL SWATCHES
  $('.swatch.upsell :radio').on('click', function() {
    Shopify.updateOptionsInSelector(1);
  });

  // ADD TO CART
  $("#addToCart").on("click", function () {
    var data = $("#add-item-form").serializeArray();
    var q = $("#quantity").val();
    
    console.log(data);

    addToCart();

    function addToCart() {

      if(typeof data[0] == 'undefined') {
        return window.location = "/cart";
      }

      if(data[0].value == "skip" || data[0].name == "quantity" || data[0].name.startsWith("option-0") || data[0].name.startsWith("option-1") || data[0].name.startsWith("option-2") || data[0].name == "zooomyalertemail") {

        data.shift();
        return addToCart();
      }

      

      Shopify.addItem(data[0].value, q, function () {

        data.shift();
        addToCart();
      });
    }
  });
});